import axios from 'axios';
import { stringify } from 'qs';
const API = (commonApiUrl, credentialsAllowed) => axios.create({
    timeout: 10000,
    paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: 'repeat' }) },
    withCredentials: credentialsAllowed,
    baseURL: commonApiUrl
});
export default API;
//# sourceMappingURL=ApiUtil.js.map